import React from 'react';
import { useObserver } from 'mobx-react-lite';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useUser from 'src/hooks/use-user';

import { PersonalizedProductsQuery } from 'src/personalization/data-layer/types';

import { LoggedOutV2 } from './logged-out-v2';
import { LoggedIn } from './logged-in';
import { LoggedInV2 } from './logged-in-v2';

type PersonalizedProductsProps = {
  personalizedProductsQuery: PersonalizedProductsQuery;
};

export const PersonalizedProducts = (props: PersonalizedProductsProps): JSX.Element | null => {
  const user = useUser();
  const flags = useFlags();
  const isLoggedIn = useObserver(() => user.isLoggedIn);

  const { personalizedProductsQuery } = props;
  const { data, loading } = personalizedProductsQuery;
  const hasNoProducts = !data?.getPersonalizedProducts?.products.length;

  if (!loading && hasNoProducts) {
    return null;
  }

  const isProductCardsV2Enabled = flags['growth.ecomm.product-card-v2.rollout'] ?? false;
  const isLoyaltyPersonalizationCtaEnabled =
    flags['growth.ecomm.logged-out-loyalty-personalization-cta.rollout'] ?? false;

  const productQueryProps = {
    personalizedProductsQuery,
  };

  const LoggedInComponent = isProductCardsV2Enabled ? LoggedInV2 : LoggedIn;
  const renderComponent = isLoggedIn ? <LoggedInComponent {...productQueryProps} /> : <LoggedOutV2 />;

  // With this new flag enabled, we are moving this logged out CTA up a level
  if (isLoyaltyPersonalizationCtaEnabled && !isLoggedIn) {
    return null;
  }

  return <div data-testid='personalized-products'>{renderComponent}</div>;
};
